import request from '@/utils/request'

export function getRestaurantInfo(query) {
  return request({
    url: '/fastFood/restaurantInfo',
    method: 'get',
    params: query,
  })
}

export function checkAccount(query) {
  return request({
    url: '/fastFood/checkName',
    method: 'get',
    params: query,
  })
}

export function serverLogin(data) {
  return request({
    url: '/dish/checkWaiterPassword',
    method: 'post',
    data,
  })
}

export function checkRucDni(query) {
  return request({
    url: '/tax/checkRuc',
    method: 'get',
    params: query,
  })
}

export function getAllTables(query) {
  return request({
    url: '/fastFood/allTables',
    method: 'get',
    params: query,
  })
}

export function getAllWaiters(query) {
  return request({
    url: '/fastFood/allWaiter',
    method: 'get',
    params: query,
  })
}

export function getAllFoodPack(query) {
  return request({
    url: '/fastFood/allFoodPack',
    method: 'get',
    params: query,
  })
}

export function queryFood(query) {
  return request({
    url: '/fastFood/queryFood',
    method: 'get',
    params: query,
  })
}

export function getUnPayedOrderCount(query) {
  return request({
    url: '/fastFood/unpayedOrderCount',
    method: 'get',
    params: query,
  })
}

export function getFoodAdjust(query) {
  return request({
    url: '/food/item4peru',
    method: 'get',
    params: query,
  })
}

export function searchTakeOutInfo(query) {
  return request({
    url: '/deliverInfo/search',
    method: 'get',
    params: query,
  })
}

export function checkMember(data) {
  return request({
    url: '/fastFood/checkMember',
    method: 'post',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/api/getInfo.js